import React from 'react';
import { RoleType } from '../../../../common/enums/RoleType';
import { ITab } from '../../../../common/models/common/ITab';
import Icon from '../../../../components/Icon';

export const getSettingsTabs = (role: RoleType): ITab[] => {
  const tabs = [
    {
      name: 'profile',
      icon: () => <Icon icon="user" />
    },
    {
      name: 'notifications',
      icon: () => <Icon icon="bell" />
    },
    {
      name: 'messages',
      icon: () => <Icon icon="messageBubbleSecond" />
    }
  ];

  if (role !== RoleType.User) {
    const adminTabs = [...tabs, {
      name: 'users', icon: () => <Icon icon="candidates" />
    }, {
      name: 'integrations', icon: () => <Icon icon="merge" />
    }, {
      name: 'tokens', icon: () => <Icon icon="lock" />
    }, {
      name: 'counters', icon: () => <Icon icon="candidates" />
    }];
    return role === RoleType.SuperAdmin
      ? [...adminTabs, { name: 'form', icon: () => <Icon icon="preview" /> }]
      : adminTabs;
  }
  return tabs;
};
